module.exports = __webpack_public_path__ + "img/bolsa-trabajo.a47dffb8.png";